import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import * as actions from '../../actions';
import { useOtpResendLock } from '../../hooks';
import messages from '../../messages';
const OtpResendBtn = ({ lockoutDuration = 0 })=>{
    const resendOtp = useAction(actions.resendOtp);
    const { resendLock, setResendLock } = useOtpResendLock();
    const labelMessage = messages.buttons[resendLock && !lockoutDuration ? 'resendOtpBtnLock' : 'resendOtpBtn'];
    const onResend = (evt)=>{
        evt.preventDefault();
        evt.stopPropagation();
        resendOtp();
        setResendLock();
    };
    return /*#__PURE__*/ _jsx(Button, {
        styleModifier: "primary",
        labelMessage: labelMessage,
        labelMessageValues: {
            resendLock
        },
        className: "btn--block",
        isDisabled: !!(resendLock || lockoutDuration),
        onClick: onResend
    });
};
export default OtpResendBtn;
